import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
export default function ChildrenItem({ sTitle, sID }) {
  const navigate = useNavigate();

  const handleOpenChildren = () => {
    navigate("/PublishedDocuments?sID=" + sID);
  };
  return (
    <>
      <Grid
        item
        container
        xs={12}
        ml={"16px"}
        mt={1}
        sx={{
          padding: "8px !important",
          color: "#070043",
          borderRadius: "50px",
          background: "linear-gradient(90deg, rgb(107 206 255) 0%, rgb(223 253 255) 100%)",
          boxShadow: "1px 7px 25px -3px rgba(0,0,0,0.3)",
        }}
        flexDirection={"row"}
        justifyContent={"space-between"}
      >
        <Grid item sx={{ mt: "5px", ml: "10px" }}>
          <Typography>{sTitle}</Typography>
        </Grid>
        <Grid item sx={{ mr: "10px" }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#758290",
              color: "white",
              borderRadius: "20px",
            }}
            onClick={() => handleOpenChildren()}
            endIcon={<ArrowForwardIosIcon />}
          >
            เพิ่มเติม
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
